import { useApiClient } from "@/api/client";
import DocumentDO = App.Data.Explorer.DocumentDO;
import { processedDocument } from "chartjs-graph";
import useToast from "@/ui/composables/useToast";
import ExportFileType = App.Enums.ExportFileType;
import { ApiError, Result } from "@/api/base";

type DownloadFunction = (
	document: DocumentDO,
	format: ExportFileType
) => Promise<Result<string, ApiError>>;

const explorer = useApiClient("explorer");

const downloadFunctions: Record<string, DownloadFunction> = {
	"data-table": explorer.downloadDataTable.bind(explorer),
	"underlying-data": explorer.downloadUnderlyingData.bind(explorer),
	"graph-data": explorer.downloadGraphData.bind(explorer),
};

export async function downloadData(
	document: DocumentDO,
	format: ExportFileType,
	dataType: "data-table" | "underlying-data" | "graph-data"
) {
	const response = await downloadFunctions[dataType](
		processedDocument(document),
		format
	);

	if (response.isErr()) {
		useToast().error("Sorry something went wrong...", {
			title: "Export failed",
			timeout: 5000,
		});
	}
}
